/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * this is the menu from the entity
 */
export interface EntityMenu { 
    show?: boolean;
    title_label?: string;
    sort?: number;
    /**
     * jsonString for the link of the menu
     */
    link?: string;
}

